import { useInitializeAnalytics, app } from '@/config/analytics'
import { useOptionalUser } from '@/pages/user/selectors'
import { getAnalytics, setUserId, setUserProperties } from 'firebase/analytics'
import { useEffect } from 'react'

export function useAnalytics() {
  useInitializeAnalytics()
  const user = useOptionalUser()
  useEffect(() => {
    if (user) {
      const analytics = getAnalytics(app)
      setUserId(analytics, `${user?.id}`)
      setUserProperties(analytics, {
        duprUserId: `${user?.id}`,
        gender: user?.gender,
        hand: user?.hand,
        area: user?.addresses?.[0]?.shortAddress,
      })
    }
  }, [user])
}
